import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../../../../../../BaseComponents';
import { useClearLastExchange } from '../../lib/useClearLastExchange';
const ClearLastExchangeButton = ({ label, isLoading }) => {
    const { t } = useTranslation('Checkout');
    const { onClearLastExchange } = useClearLastExchange();
    return (React.createElement(BaseButton, { variant: "action", isLoading: isLoading, onClick: onClearLastExchange }, label || t('ClearLastExchangeButton.Label')));
};
export default ClearLastExchangeButton;
